import React from 'react';

import styles from '../statics/styles/file-upload-viewer-scss';

export const PdfIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="42" viewBox="0 0 40 42" {...props}>
    <g fill="none" fillRule="evenodd">
      <g className={styles.file_upload_icon_frame} strokeLinejoin="bevel">
        <path fill="currentColor" d="M35.5 41.5h-32V.5h19.45L35.5 13.31z" />
        <path d="m22.59 13.36 12.91-.05-.64-.63L23.59 1.14 22.95.5z" />
      </g>
      <path
        className={styles.file_upload_icon_background}
        d="M25.982 27.818s0 .1 0 0c0 .1-.2.2-.6.2h-.3c-.4-.1-1-.4-1.6-.9 1.7.1 2.3.5 2.5.7zm-5-1.7c-.6.1-1.4.2-2.4.4.4-.8.7-1.5 1-2.2.1.1.2.3.3.4.4.4.8.9 1.1 1.4zm-1.9-6.9c.1-.2.2-.3.2-.3.1.1.3.4.2 2 0 .3-.1.6-.2 1-.3-1-.4-2-.2-2.7zm-4.5 11.3c-.2.1-.3.2-.5.2 0-.1.1-.6.8-1.3.4-.3.8-.7 1.3-.9-.6 1-1.2 1.8-1.6 2zm7.8-4.5c-.6-.6-1.1-1.4-1.7-2l-.6-.9c.3-.9.5-1.6.5-2.2.1-1.4-.1-2.3-.5-2.8-.3-.3-.7-.4-1.1-.2-.3.1-.7.3-.9 1-.4 1-.2 2.9.7 4.4-.4 1.1-1 2.4-1.6 3.6-1.3.4-2.3 1-3 1.7-.9.9-1.3 1.8-1 2.5.1.5.5.7 1 .7.3 0 .7-.1 1.1-.4.9-.6 2-2.5 2.7-3.6 1.2-.4 2.5-.6 3.1-.6.3 0 .6-.1.9-.1 1.1 1.2 2.1 1.8 2.9 2h.5c.7 0 1.3-.3 1.5-.7.2-.4.2-.8 0-1.1-.5-.8-1.9-1.3-4-1.3h-.5z"
      />
    </g>
  </svg>
);
